import { ApiCustomFieldValue } from "@/types/custom-field.types";
import { CompensationLineSave } from "@/types/employees/employee-compensation.types";
import { ApiEmployeeEditPayload, ApiEmployeeSetupPayload } from "@/types/employees/employee.types";
import { ApiApplicant } from "@/types/recruit/applicant.types";
import { ApiJob } from "@/types/recruit/job.types";
import { ApiOffer } from "@/types/recruit/offer.types";

export interface PrefillCandidate {
  applicant: ApiApplicant;
  job?: ApiJob;
  offer?: ApiOffer;
}

export interface ApiEmployeeHirePackage {
  change_reason_id: number | null;
  comment: string | null;
  currency: string | null;
  lines: CompensationLineSave[];
  custom_fields: Record<string, ApiCustomFieldValue | null>;
}

export interface ApiEmployeeHireWorkflow {
  workflow_id: number;
  block_portal_access: boolean;
}

export interface ApiEmployeeHirePayload {
  hiring_flow_id: number | null;
  main: Omit<
    ApiEmployeeSetupPayload,
    "base_salary_gross" | "base_salary_net" | "currency" | "per_type"
  > & { custom_fields: Record<string, ApiCustomFieldValue> };
  personal: Omit<
    ApiEmployeeEditPayload,
    "first_name" | "last_name" | "middle_name" | "date_hired_on"
  >;
  compensation: ApiEmployeeHirePackage | null;
  enable_probation: boolean;
  date_probation_ends: Date | null;
  compensation_after_probation: ApiEmployeeHirePackage | null;
  workflows: ApiEmployeeHireWorkflow[];
  idempotency_key?: string | null;
}

export enum ProcessingJobStatus {
  queued = "queued",
  running = "running",
  completed = "completed",
  failed = "failed",
}

export interface ApiEmployeeHireJobQueued {
  job_id: number;
  access_key: string;
  status: ProcessingJobStatus;
}

export interface ApiEmployeeHireJobStatus {
  job_id: number;
  status: ProcessingJobStatus;
  employee_id: number | null;
  error_code: string | null;
  error_message: string | null;
  datetime_created_at: Date;
  datetime_finished_at: Date | null;
}
